import React from "react";
import { ChevronLeft, Phone, MessageCircle, Mail } from "lucide-react";

const CustomerServicePage = ({ onBack }) => (
  <div>
    <button
      onClick={onBack}
      className="flex items-center gap-1 mb-3 text-sm text-gray-600"
    >
      <ChevronLeft size={18} /> Back
    </button>
    <h3 className="text-lg font-semibold mb-3 text-gray-800">Customer Service</h3>
    <div className="space-y-3">
      <div className="flex items-center gap-2 border p-3 rounded-md hover:bg-gray-50 cursor-pointer">
        <Phone size={18} className="text-amber-600" /> Call Support
      </div>
      <div className="flex items-center gap-2 border p-3 rounded-md hover:bg-gray-50 cursor-pointer">
        <MessageCircle size={18} className="text-amber-600" /> Chat with Us
      </div>
      <div className="flex items-center gap-2 border p-3 rounded-md hover:bg-gray-50 cursor-pointer">
        <Mail size={18} className="text-amber-600" /> Email Support
      </div>
    </div>
  </div>
);

export default CustomerServicePage;
